import { useEffect, useState } from "react";
import { FolderOpen, Search } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { RESOURCE_ICONS, isMediaResource, openTeachingResource, ResourcePlayerDialog } from "@/pages/enseignement/teachUtils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// « Mes ressources » — vue élève : uniquement les ressources explicitement partagées avec lui (§18/§19)
export default function MesRessourcesPage() {
  const { t } = useAuth();
  const [resources, setResources] = useState([]);
  const [search, setSearch] = useState("");
  const [player, setPlayer] = useState(null);
  const openRes = (r) => (isMediaResource(r) ? setPlayer(r) : openTeachingResource(r));

  useEffect(() => {
    api.get("/teaching/resources").then((r) => setResources(r.data.resources)).catch(() => {});
  }, []);

  const q = search.trim().toLowerCase();
  const filtered = q ? resources.filter((r) => r.title.toLowerCase().includes(q)) : resources;

  return (
    <div className="space-y-4" data-testid="student-resources-page">
      <h2 className="font-heading text-2xl font-bold flex items-center gap-2">
        <FolderOpen className="h-6 w-6 brand" /> {t("teach.my_resources")}
      </h2>

      <div className="relative max-w-sm">
        <Search className="h-4 w-4 t-secondary absolute left-3 top-1/2 -translate-y-1/2" />
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={t("common.search")} className="pl-9 bg-transparent border-app" data-testid="student-resource-search" />
      </div>

      {filtered.length === 0 ? (
        <p className="text-sm t-secondary py-8 text-center" data-testid="student-resources-empty">{t("teach.no_resources_student")}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="student-resources-list">
          {filtered.map((r) => {
            const Icon = RESOURCE_ICONS[r.type] || RESOURCE_ICONS.document;
            return (
              <div key={r.id} className="app-card p-4 space-y-2" data-testid={`student-resource-${r.id}`}>
                <div className="flex items-start gap-3">
                  <Icon className="h-5 w-5 brand shrink-0 mt-0.5" />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold truncate">{r.title}</p>
                    <p className="text-xs t-secondary">{t(`teach.type_${r.type}`)}</p>
                  </div>
                </div>
                <Button size="sm" variant="outline" className="border-app h-8 text-xs w-full" onClick={() => openRes(r)} data-testid={`student-resource-open-${r.id}`}>
                  {t(r.type === "link" ? "teach.open_link" : isMediaResource(r) ? "mp.play" : "teach.download")}
                </Button>
              </div>
            );
          })}
        </div>
      )}
      {player && <ResourcePlayerDialog resource={player} onClose={() => setPlayer(null)} />}
    </div>
  );
}
